import { render } from "./courseware.vue?vue&type=template&id=ba348230&scoped=true"
import script from "./courseware.vue?vue&type=script&lang=ts"
export * from "./courseware.vue?vue&type=script&lang=ts"

import "./courseware.vue?vue&type=style&index=0&id=ba348230&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba348230"

export default script